module.exports = __webpack_public_path__ + "img/phone.d28c084e.png";